import React from "react";
import backImage from "../../assets/icons/arrow-back-black.svg";
import blackBackImg from "../../assets/icons/arrow-back-black.svg";
import closeImg from "../../assets/images/ic_close.png";
import RippleButton from "./RippleButton";
import arrowBack from "../../assets/icons/arrow-back.png";
import { useHistory, useLocation } from "react-router";
import { goBackTo } from "../../containers/navigo/utils/navBack";
import { useEffect } from "react";
import {  } from "@ionic/react";

// export default class BackButton extends Component {
//   constructor() {
//     super();
//   }

//   render() {
//     const { history, isClose, whiteButton } = this.props;
//     return(

//     )
//   }
// }

const BackButton = (props) => {
  const { history, isClose, whiteButton, isBlack, onBack, fallback } = props;
  const localHistory = useHistory();
  const routeLocation = useLocation();

  function handleRedirect() {
    if (typeof onBack === "function") {
      onBack();
      return; // prevent further navigation
    }
    // Never pop. history.goBack() / NavContext goBack() take the view out of
    // our SPA document inside MLI's WebView: the screen goes blank and even a
    // plain setInterval stops running, so nothing of ours is alive to recover.
    // See containers/navigo/utils/navBack.js.
    //
    // Prefer the route recorded by whoever pushed this screen (state.from),
    // then an explicit `fallback` prop, then the home tab.
    goBackTo(history || localHistory, routeLocation, fallback || "/tab/home");
  }
  let style1 = {
    width: "30px",
    height: "30px",
  };
  let style2 = {
    height: "20px",
  };

  return (
    <button className="bg-transparent p-0">
      {!whiteButton && (
        <img
          className={`${isBlack ? "black-back-img" : ""}`}
          onClick={() => {
            handleRedirect();
          }}
          src={!isClose ? (isBlack ? blackBackImg : backImage) : closeImg}
          style={isBlack ? style1 : props.style ? props.style : style2}
        />
      )}
      {whiteButton && (
        <img
          onClick={() => {
            if (props.removeMedicineDocument) {
              props.removedMedDocFunc();
            }
            localHistory.replace("/tab/home");
          }}
          src={arrowBack}
          // style={{ height: "40px" }}
        />
      )}
    </button>
  );
};
export default BackButton;
